"use client"

import { ColumnDef } from "@tanstack/react-table"
import { ArrowUpDown } from "lucide-react"
import { Button } from "@/components/ui/button"

import { Checkbox } from "@/components/ui/checkbox"
import UserRowActions from "./UsersRowActions"
import { format } from "date-fns"

export type Users = {
    id: string
    user_name: string
    role_name: string
    role_id: number
    status: number
    email: Date
    remember_token: string
    created_at: Date
    updated_at: Date
    password: string
}
interface rowActionProps {
    onEdit: (data: any) => void;
    onDelete: (data: any) => void;
    onChangePassword: (data: any) => void;
    roles: string[]
}

export const usersColumns = ({ onEdit, onDelete, onChangePassword, roles }: rowActionProps): ColumnDef<Users>[] => {
    const columns: ColumnDef<Users>[] = [
        {
            accessorKey: "id",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Id
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
        },
        {
            accessorKey: "user_name",
            header: "Name",
        },
        {
            accessorKey: "email",
            header: "Email",
        },
        {
            accessorKey: "role_name",
            header: "Role",
            cell: ({ row }) => {
                const value: any = row.original
                const statusText = value.role_name
                return (
                    <span className={`  px-2 rounded-full bg-green-500 text-white`}>
                        {statusText}
                    </span>
                );
            },
        },
        {
            accessorKey: "created_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Created At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.created_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>
            },
        },
        {
            accessorKey: "updated_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Updated At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.updated_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>
            },
        },

    ]

    if (roles.includes('user-edit') || roles.includes('user-delete')) {
        columns.push({
            id: "actions",
            header: 'Actions',
            cell: ({ row }) => <UserRowActions row={row} onEdit={onEdit} onDelete={onDelete} onChagePassword={onChangePassword} roles={roles} />,
        })
    }
    return columns
}
